import { useTranslation } from 'react-i18next';

interface HeroSearchProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
}

export default function HeroSearch({ searchQuery, onSearchChange }: HeroSearchProps) {
  const { t } = useTranslation();

  return (
    <section className="pt-24 pb-8 px-6 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
          {t('tagline')}
        </h2>
        
        <div className="relative mt-8">
          <div className="absolute inset-y-0 left-4 flex items-center pointer-events-none">
            <i className="ri-search-line text-xl text-gray-400"></i>
          </div>
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder={t('searchPlaceholder')}
            className="w-full pl-12 pr-4 py-4 text-base border border-gray-200 rounded-2xl focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent shadow-sm cursor-text"
          />
        </div>
      </div>
    </section>
  );
}
